import axios from "axios";

class Order {
    constructor() {
        this.url = `/api/v1/orders`;
    }

    get(id) {
        return axios.get(`${this.url}/${id}`);
    }

    create(order) {
        return axios.post(`${this.url}/`, order);
    }

    update(id, order) {
        return axios.put(`${this.url}/${id}`, order);
    }

    delete(id) {
        return axios.delete(`${this.url}/${id}`);
    }

    cancel(id) {
        return axios.put(`${this.url}/${id}/cancel`);
    }
}

export default Order;